import { queryOptions } from '@tanstack/react-query';
import { getSystemSimulation } from '~/services/api/fetchers/simulations.api';
import { SimulationModel } from '~/shared/models/system/SimulationModel';
import { assertIsDefined } from '~/types/assert-type';

export const getSystemSimulationQuery = ({
  simulationId,
}: {
  simulationId: string;
}) =>
  queryOptions({
    queryKey: ['getSystemSimulation', { simulationId }],
    queryFn: async () => {
      const { simulation } = await getSystemSimulation({
        simulationId,
      });

      assertIsDefined(simulation);
      return new SimulationModel(simulation);
    },
  });
